import React from "react";

import LegalLayout from "../LegalLayout";

function CGV() {
  return (
    <LegalLayout title="Conditions générales de vente">
      <h2 className="fs-4 mt-4">1. Objet</h2>

      <p>
        Les présentes Conditions Générales de Vente (CGV) s’appliquent à
        l’ensemble des prestations de formation dispensées par <strong>SAS Autoformation</strong> dans le cadre de la formation professionnelle
        continue, au sens de l’article L6313-1 du Code du travail.
      </p>

      <h2 className="fs-4 mt-4">2. Documents contractuels</h2>

      <p>Toute action de formation donne lieu à :</p>

      <ul>
        <li>
          une convention de formation (art. L6353-2 du Code du travail)
          lorsqu’il s’agit d’une personne morale (entreprise, association,
          collectivité),
        </li>
        <li>
          un contrat de formation professionnelle (art. L6353-3 du Code du
          travail) lorsqu’il s’agit d’une personne physique à titre individuel.
        </li>
      </ul>
      <p>
        Ces documents précisent notamment : l’intitulé, les objectifs, le
        programme, la durée, les modalités d’exécution, les moyens pédagogiques
        et techniques, ainsi que le prix de la formation.
      </p>

      <h2 className="fs-4 mt-4">3. Inscription et confirmation</h2>

      <p>
        L’inscription devient définitive à réception : du devis signé ou du
        bulletin d’inscription validé,et, le cas échéant, du règlement de
        l’acompte prévu.
      </p>

      <p>
        L’organisme se réserve le droit de refuser une inscription en cas de
        non-paiement des prestations antérieures ou si le nombre de participants
        maximum est atteint.
      </p>
      <h2 className="fs-4 mt-4">4. Prix et modalités de paiement</h2>

      <p>
        Les tarifs sont indiqués en euros, nets de taxes (TVA non applicable –
        art. 293 B du CGI, le cas échéant). Le paiement s’effectue :
      </p>

      <ul>
        <li>
          selon les conditions précisées dans la convention/contrat (acomptes,
          échéancier, solde),
        </li>
        <li>par virement bancaire, chèque ou tout autre moyen accepté.</li>
      </ul>

      <p>
        En cas de financement par un OPCO (ou autre organisme financeur), il
        appartient au Client d’effectuer les démarches nécessaires. Si la prise
        en charge n’est pas confirmée avant le début de la formation, le coût
        sera intégralement facturé au Client.
      </p>

      <h2 className="fs-4 mt-4">
        5. Conditions d’annulation, de report et d’abandon
      </h2>

      <p>
        Annulation par le Client : toute annulation doit être notifiée par
        écrit.
      </p>

      <p>Plus de 15 jours avant le début de la formation : aucune indemnité.</p>

      <p>Entre 15 et 7 jours : facturation de 30 % du montant.</p>

      <p>Moins de 7 jours : facturation de 50 % du montant.</p>

      <p>Après le début : la totalité du prix est due.</p>

      <p>
        Annulation par l’Organisme : l’organisme se réserve le droit d’annuler
        ou reporter une session en cas d’insuffisance d’inscriptions,
        d’indisponibilité d’un formateur ou de force majeure. Le Client en sera
        informé dans les meilleurs délais et toute somme déjà versée sera
        remboursée.
      </p>

      <h2 className="fs-4 mt-4">6. Déroulement des formations</h2>

      <p>
        Les formations sont réalisées selon les modalités prévues (présentiel,
        distanciel synchrone ou asynchrone, blended learning). <br></br>
        L’organisme s’engage à :
      </p>
      <ul>
        <li>fournir des moyens pédagogiques adaptés,</li>
        <li>fournir des moyens pédagogiques adaptés,</li>
        <li>désigner un formateur compétent,</li>
        <li>
          remettre aux stagiaires une attestation de présence ou de fin de
          formation.
        </li>
      </ul>
      <h2 className="fs-4 mt-4">7. Obligations des participants</h2>
      <p>Les stagiaires s’engagent à :</p>
      <ul>
        <li>respecter les horaires et la durée de la formation,</li>
        <li>
          adopter un comportement respectueux envers les formateurs et les
          autres participants,
        </li>
        <li>utiliser le matériel mis à disposition avec soin,</li>

        <li> respecter le règlement intérieur applicable,</li>

        <li>participer activement aux sessions,</li>

        <li>se conformer aux consignes pédagogiques et de sécurité.</li>
      </ul>
      <h2 className="fs-4 mt-4">8. Responsabilité</h2>

      <p>
        L’Organisme est soumis à une obligation de moyens et non de résultat.
      </p>
      <p>
        Sa responsabilité ne peut être engagée en cas : de force majeure,
        d’absence ou de retard du stagiaire, d’inadéquation du contenu de la
        formation aux objectifs particuliers du Client qui n’auraient pas été
        exprimés préalablement.
      </p>

      <p>
        La responsabilité de l’Organisme est limitée au montant de la prestation
        facturée.
      </p>

      <h2 className="fs-4 mt-4">9. Propriété intellectuelle</h2>

      <p>
        Tous les supports pédagogiques, quelle qu’en soit la forme (papier,
        numérique, vidéo, etc.), demeurent la propriété exclusive de l’Organisme
        ou de ses partenaires. Toute reproduction, représentation ou diffusion,
        totale ou partielle, sans autorisation écrite, est interdite.
      </p>

      <h2 className="fs-4 mt-4">10. Données personnelles</h2>

      <p>
        L’Organisme traite les données des Clients et des stagiaires
        conformément au Règlement Général sur la Protection des Données (RGPD).
        Les informations collectées sont utilisées uniquement pour la gestion
        administrative, commerciale et pédagogique.
      </p>
      <p>
        Conformément à la loi « Informatique et Libertés », chaque personne
        dispose d’un droit d’accès, de rectification et de suppression en
        contactant l’Organisme à l’adresse suivante : <strong>contact@auto-formations.fr</strong>.
      </p>

      <h2 className="fs-4 mt-4">11. Droit applicable et litiges</h2>

      <p>Les présentes CGV sont régies par le droit français.</p>
      <p>
        Tout litige qui ne pourrait être résolu à l’amiable sera soumis aux
        tribunaux compétents du ressort du siège social de l’Organisme.
      </p>
    </LegalLayout>
  );
}

export default CGV;
